import React from "react";
import { FaCamera, FaRandom, FaCommentAlt, FaCheck } from "react-icons/fa"; // Importing React Icons
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faT, faI, faL, faA, faC,
} from "@fortawesome/free-solid-svg-icons"; 
import Aboutus from '../../assets/aboutus-1.jpeg';
import Teamwork from '../../assets/teamwork.jpeg';

// About map
const stories = [
  {
    text: "Grow your wealth with expert advice and tailored investment plans.",
  },
  {
    text: "Maximize your savings with safe and lucrative options.",
  },
  {
    text: "Flexible loan solutions to help you reach your dreams.",
  },
  {
    text: "Plan for your future with comprehensive retirement strategies.",
  },
  {
    text: "We care your life and value your wealth",
  },
];

const StoryItem = ({ item, index }) => {
  const { text } = item;
  return (
    <>
      <div className="mb-4">
        <ul className="list-disc list-inside">
          <li className="opacity-75 text-base">{text}</li>
        </ul>
      </div>

      {index !== stories.length && <hr className="w-11/12 my-2" />}
    </>
  );
};



const features = [
  {
    icon: faT,
    title: "Teamwork",
    desc: "Value the input and ideas of others, regardless of position.Work together to achieve shared goals.Foster a supportive and inclusive environment.",
  },
  {
    icon: faI,
    title: "Intigrity",
    desc: "Act honestly and transparently in all interactions. Foster trust by maintaining a high ethical standard. Hold yourself and others accountable.",
  },

  {
    icon: faL,
    title: "Loyalty",
    desc: "A strong commitment to a company's values, mission, and vision. When your people choose to continue working with you for a long time because they love doing so Employee LOYALTY drives productivity and collaboration",
  },
  {
    icon: faA,
    title: "Accountablity",
    desc: "Take ownership of your actions and their outcomes. Admit mistakes and take steps to improve. Hold yourself and others to a high standard of responsibility",
  },
  {
    icon: faC,
    title: "Creativity",
    desc: "Encourage creative thinking and problem-solving. Be open to new ideas and technologies that improve the business Embrace change as an opportunity for growth.",
  },
];

const FeaturedItem = ({ feature }) => {
  const isFirstItem = feature === features[0];
  const isSecondItem = feature === features[1];

  return (
    <div className={`flex items-start ${isFirstItem ? "!mt-0" : ""}`}>
      <div className="mr-4 flex items-center">
        <span
          className={`w-9 h-9 rounded-full text-xl flex items-center justify-center ${
            isFirstItem
              ? "bg-darkBlue text-white"
              : isSecondItem
              ? "bg-darkBlue text-white"
              : "bg-darkBlue text-white"
          }`}
        >
          <FontAwesomeIcon icon={feature.icon} />
        </span>
      </div>
      <div>
        <h1 className="text-lg text-darkBlue font-bold leading-tight md:text-[20px] flex items-center">
          {feature.title}
        </h1>
        <p className="opacity-80">{feature.desc}</p>
      </div>
    </div>
  );
};





FeaturedItem.propTypes = {
  feature: PropTypes.object.isRequired,
};
const Aboutnew = ({ hideAbout = false }) => {
  return (
    <React.Fragment>
      {!hideAbout && <section className="ezy__about9 light py-14 md:py-10 bg-skyBlue  text-zinc-900 ">
        <div className="container px-4 max-w-7xl mx-auto">
          <div className="grid grid-cols-12 items-center gap-4 mb-1 ">
            <div className="col-span-12 lg:col-span-6 sm:order2">
              <h1 className="sm:order-1 text-3xl font-bold leading-tight md:text-[40px] mb-4 uppercase">
                About Us
              </h1>
              {/* <hr className="bg-darkBlue h-1 rounded-[3px] w-12 opacity-100 my-6" /> */}
              <p className="opacity-70 mb-2 sm:order-3">
                At Infrec, we specialize in providing innovative financial solutions that empower individuals and businesses to achieve their goals. Our expert team ensures that you get personalized services, whether you're looking to invest, save, or plan for the future.
                With decades of experience and a commitment to transparent, client-focused strategies, we are here to guide you through every step of your financial journey.
              </p>
              <ul className="flex flex-col text-base mt-5">
                {stories.map((item, i) => (
                  <li key={i}>
                    <StoryItem item={item} index={i + 1} />
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-12 lg:col-span-6 sm:order-2">
              <div className="mt-0 lg:mt-0">
                <img
                  src={Aboutus}
                  alt=""
                  className="max-w-full h-auto rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>}

      <section className="py-12 md:py-24 bg-white relative overflow-hidden z-10">
        <div className="container px-4 mx-auto">
          <div className="grid grid-cols-12 gap-6 items-center">
            {/* Left Column */}
            <div className="col-span-12 md:col-span-6 lg:col-span-5 lg:col-start-2">
              <h1 className="text-3xl font-bold leading-tight md:text-[40px] mb-10 uppercase">
                Our Values
              </h1>
              <img
                src={Teamwork}
                alt="Descriptive Alt Text"
                className="w-full h-64 sm:h-80 md:h-[55vh] lg:h-[65vh] object-cover rounded-lg mt-4"
              />
            </div>

            {/* Right Column */}
            <div className="col-span-12 md:col-span-6 lg:col-span-5">
              <div className="space-y-6">
                {features.map((feature, i) => (
                  <FeaturedItem feature={feature} key={i} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>


    </React.Fragment>
  );
};

export default Aboutnew;
